
import { defineComponent, PropType, ref, watch } from 'vue'
import MembersEditableFieldEmail from '@/components/members/editable-fields/email.vue'
import MembersEditableFieldFirstName from '@/components/members/editable-fields/first-name.vue'
import MembersEditableFieldLastName from '@/components/members/editable-fields/last-name.vue'
import { MemberProfile } from '@/modules/members'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import MembersChangeMemberPasswordDialog from '@/components/members/dialogs/change-member-password.vue'
import MembersEditableFieldJobTitle from '@/components/members/editable-fields/job-title.vue'
import MembersEditableFieldPreferredLanguage from '@/components/members/editable-fields/preferred-language.vue'
import MembersEditableFieldOrganization from '@/components/members/editable-fields/organization.vue'
import MembersEditableFieldAllowMarketing from '@/components/members/editable-fields/allow-marketing-communication.vue'

export default defineComponent({
    name: 'members-show-edit-member-personal-info',
    components: {
        MembersEditableFieldAllowMarketing,
        MembersEditableFieldJobTitle,
        MembersEditableFieldEmail,
        MembersEditableFieldFirstName,
        MembersEditableFieldLastName,
        MembersEditableFieldOrganization,
        MembersEditableFieldPreferredLanguage
    },
    props: {
        member: {
            type: Object as PropType<MemberProfile>,
            required: true
        }
    },
    async setup (props) {
        const $q = useQuasar()
        const memberPersonalInfoModel = ref(props.member)
        function onChangePassword () {
            $q.dialog({
                component: MembersChangeMemberPasswordDialog,
                componentProps: {
                    memberId: props.member.memberId
                }
            })
        }

        return {
            memberPersonalInfoModel,
            onChangePassword
        }
    }
})
